export const INSIGHTS_ROUTE = '/insights';
